import React from "react";
import { PASSWORD_CHAR_CATEGORIES, PASSWORD_VALIDATION_RULE } from "constants/password-validation-rules";
import styles from "./password-validation-rules.module.scss";

export function PasswordValidationRules() {
    return (
        <div className={styles["password-validation-rules-desc"]}>
            {PASSWORD_VALIDATION_RULE}
            <ul>
                {PASSWORD_CHAR_CATEGORIES.map((x, i) => <li key={`pwd-rule-${i}`}>{x}</li>)}
            </ul>
        </div>
    );
}